import { connect } from 'react-redux';
import Component from '../../components/js/modules/YahooAnalytics';
import { IStates } from '../CommonStateType';

const mapStateToProps = (state: IStates) => ({
  mtestid: state.pageData.pageParam.mtestid ?? undefined
});

export default connect(mapStateToProps)(Component);
